/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Principal
 * 2 = Mobile
 * 3 = Bureau
 * 4 = Autre
 */
export enum TypeTelephone {
  Principal = 1,
  Mobile = 2,
  Bureau = 3,
  Autre = 4
}
